export const BrandWordmark = ({ className = "h-9" }) => (
  <img
    src="/brand/videoileo-wordmark.png"
    alt="Videoileo — AI Short Video Builder"
    draggable="false"
    data-testid="brand-wordmark"
    className={`${className} w-auto select-none`}
  />
);
